import { useQuery } from "react-query";
import { TeamAPI } from "api/admin/team";
import { TEAM_PARTICIPANTS } from "helpers/constants";

export default function useTeamParticipantsForCompetition(competitionId) {
  return useQuery(
    [TEAM_PARTICIPANTS, "competition", competitionId],
    () => TeamAPI.getAllParticipantsForCompetition(competitionId),
    { enabled: competitionId }
  );
}
